import { render, staticRenderFns } from "./TenantUserList.vue?vue&type=template&id=380105de"
import script from "./TenantUserList.vue?vue&type=script&lang=js"
export * from "./TenantUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports